import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const TrainingDev = () => {
  return (
    <div className="w-full bg-white">
      <PageHeader 
        title="Training & Development" 
        description="Equipping your people with the technical skills and confidence to execute safely." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="prose prose-slate prose-lg">
            <h2 className="text-brand-navy font-bold">Flexible Delivery, Custom Content</h2>
            <p>
              Whether you need to train permanent staff, contractors, temporary workers, or a multi-generational team, Boes & Boes delivers impactful education. 
            </p>
            <p>
              Programs can be delivered onsite at your facility, live online, privately for your organization, publicly as scheduled courses, or through custom blended learning models.
            </p>

            <h3 className="text-brand-navy font-bold mt-8">Training Capabilities</h3>
            <ul className="not-prose space-y-4">
              {[
                { title: 'Custom Course Development', desc: 'Curriculum built specifically around your facility\'s hazards and policies.' },
                { title: 'Train-the-Trainer Programs', desc: 'Equipping your internal staff to deliver standardized, high-quality instruction.' },
                { title: 'Facility-Specific Scenarios', desc: 'Practical activities using your actual equipment and P&IDs.' },
                { title: 'Post-Course Reinforcement', desc: 'Job tools, checklists, and refresher modules to ensure retention.' }
              ].map((item, i) => (
                <li key={i} className="flex gap-4 p-4 bg-brand-light rounded-xl border border-slate-200">
                  <div className="mt-1"><SafeIcon icon={FiIcons.FiTarget} className="text-brand-navy text-xl" /></div>
                  <div>
                    <h4 className="font-bold text-brand-navy text-base">{item.title}</h4>
                    <p className="text-sm text-slate-600 font-medium m-0">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-brand-navy p-10 rounded-3xl text-center shadow-xl">
            <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-green text-3xl" />
            </div>
            <h3 className="text-3xl font-bold text-white mb-4">Explore Our Curriculum</h3>
            <p className="text-slate-300 mb-8 font-medium">
              Browse our catalog of standard courses covering Fire & Emergency Services, Hazardous Materials, NFPA Compliance, Leadership, and AI in the Workplace.
            </p>
            <Link to="/training/catalog" className="inline-block px-8 py-4 bg-brand-green text-white font-bold rounded-xl hover:bg-green-600 transition-colors shadow-lg">
              View Course Catalog
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrainingDev;